export const styles = {
  textFileEditor: {
    width: '100%',
  },
  toolbar: {
    textAlign: 'left',
    paddingTop: '0.5em',
  },
};

export default styles;
